import { Injectable } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';

import { AssessmentQuestionBase } from './models/assessment-question-base.model';

@Injectable()
export class AssessmentQuestionControlService {
  
  toFormGroup(questions: AssessmentQuestionBase<string>[] ) {
    const group: any = {};

    questions.forEach(question => {
      group[question.key] = question.required ? new FormControl(question.value || '', Validators.required)
                                              : new FormControl(question.value || '');
    });
    return new FormGroup(group);
  }
}